import isFilledUp from './fields/isFilledUp'
import isMobileNumber from './fields/isMobileNumber'
import isEmail from './fields/isEmail'
import isPersonName from './fields/isPersonName'

const validateFirstName = (name, firstName) => {
  if (!isFilledUp(firstName)) {
    return { [name]: 'First name is required' }
  }
  if (!isPersonName(firstName)) {
    return { [name]: 'First name contains invalid characters' }
  }
  return {}
}

const validateLastName = (name, lastName) => {
  if (!isFilledUp(lastName)) {
    return { [name]: 'Last name is required' }
  }
  if (!isPersonName(lastName)) {
    return { [name]: 'Last name contains invalid characters' }
  }
  return {}
}

const validateEmail = (name, email) => {
  if (!isFilledUp(email)) {
    return { [name]: 'Email is required' }
  }
  if (!isEmail(email)) {
    return { [name]: 'Invalid email' }
  }
  return {}
}

const validateMobileNumber = (name, mobileNumber) => {
  if (!isFilledUp(mobileNumber)) {
    return { [name]: 'Mobile number is required' }
  }

  if (!isMobileNumber(mobileNumber)) {
    return { [name]: 'Invalid mobile number' }
  }

  return {}
}

const validate = values => {
  if (typeof values !== 'object' || values === null) {
    throw new Error(
      'Invalid argument. Validator functions only expect a non-null object.',
    )
  }

  const { firstName, lastName, email, mobileNumber } = values

  return {
    ...validateFirstName('firstName', firstName),
    ...validateLastName('lastName', lastName),
    ...validateEmail('email', email),
    ...validateMobileNumber('mobileNumber', mobileNumber),
  }
}

export default validate
